import { gql } from '@apollo/client';

export const CANTIDAD_PACIENTES_SIN_GEO = gql`
    query CantidadPacientesSinGeo {
        cantidadPacientesSinGeoposicion
    }
`;